import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import H5 from 'UIComponents/elements/headings/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReadOnlyViewShepherd({
  children,
  isCurrentViewModified,
  onOpenChange,
  onResetClick,
  open
}) {
  return /*#__PURE__*/_jsx(UIPopover, {
    closeOnOutsideClick: true,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkListingLib.viewTabs.saveButtonPopover.header.readOnly"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.viewTabs.saveButtonPopover.body.saveAsNewReadOnly"
      }),
      footer: /*#__PURE__*/_jsx(UIList, {
        firstChildClassName: "p-bottom-4",
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "crm-listing-popover-save-view-button",
            disabled: true,
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "frameworkListingLib.viewTabs.saveButtonPopover.footer.saveAsButton"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            "data-test-id": "crm-listing-popover-reset-button",
            disabled: !isCurrentViewModified,
            onClick: onResetClick,
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "frameworkListingLib.viewTabs.saveButtonPopover.footer.resetButton"
            })
          })]
        })
      })
    },
    "data-test-id": "read-only-view-shepherd",
    onOpenChange: onOpenChange,
    open: open,
    placement: "bottom left",
    width: 300,
    children: children
  });
}